import React, { useEffect, useMemo, useState } from 'react';
import { Button, Spinner, Tooltip } from 'reactstrap';
import { toast } from 'react-toastify';
import { get, postJson } from '../../../hook/request';

export type FavouriteButtonProps = {
  percorso: string; 
  nome: string;     
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  title?: string;  
  onChange?: (isFav: boolean) => void;
};

export default function FavouriteButton({ percorso, nome, size = 'md', className, title, onChange }: FavouriteButtonProps) {
  const [fav, setFav] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [ttOpen, setTtOpen] = useState(false);
  const tooltipId = useMemo(() => `fav-tt-${Math.random().toString(36).slice(2)}`,[percorso, nome]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const qs = new URLSearchParams({ percorso, nome }).toString();
        const res = await get<any>(`/favourite?${qs}`);
        const root: any = (res as any)?.data ?? res;
         const isFav: boolean =
          typeof root === 'boolean'
            ? root
            : root?.check === 'ok'
            ? true
            : typeof root?.isFavourite === 'boolean'
            ? root.isFavourite
            : typeof root?.data?.isFavourite === 'boolean'
            ? root.data.isFavourite
            : false;
        if (mounted) setFav(isFav);
      } catch (e: any) {
       
      }
    })();
    return () => { mounted = false; };
  }, [percorso, nome]);

  // ---- toggle ----
  const toggleFav = async () => {
    if (loading) return;
    setLoading(true);
    try {
      if (!fav) {
        await postJson('/favourite/put', { percorso, nome });
        setFav(true);
        onChange?.(true);
        toast.success('Aggiunto ai preferiti');
      } else {
        await postJson('/favourite/cancel', { percorso, nome });
        setFav(false);
        onChange?.(false);
        toast.success('Rimosso dai preferiti');
      }
    } catch (e: any) {
      const msg = e?.response?.data?.message ?? e?.message ?? 'Errore operazione preferiti';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const icon = fav ? '★' : '☆'; // stella piena/vuota
  const aria = fav ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti';

  return (
    <>
      <Button
        style={{height:35, width:55}}
        id={tooltipId}
        color={fav ? 'warning' : 'outline-secondary'}
        size={size}
        className={className + ' d-flex justify-content-center align-items-center'}
        onClick={toggleFav}
        aria-pressed={fav}
        aria-label={aria}
        disabled={loading}
      >
        {loading ? <Spinner size="sm" /> : <span style={{ fontSize: size === 'lg' ? 22 : size === 'sm' ? 14 : 18 }}>{icon}</span>}
      </Button>
      <Tooltip target={tooltipId} isOpen={ttOpen} toggle={() => setTtOpen(v => !v)} placement="top">
        {title ?? (fav ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti')}
      </Tooltip>
    </>
  );
}